import { forwardRef } from 'react';

import { RiCheckboxCircleFill, RiEdit2Line, RiTodoLine } from 'react-icons/ri';

import { ExplainerPopover } from '@elements/widgets';
import { Badge, Divider, Group, Stack, Text } from '@ui';

import classes from './Steps.module.css';

interface StepProps {
  label: string;
  index: number;
  active: boolean;
  completed: boolean;
  totalSteps: number;
}

type StepRef = HTMLDivElement;

export const Step = forwardRef<StepRef, StepProps>(
  ({ label, index, active, completed, totalSteps }, ref) => {
    const hasDoubleDigitSteps = totalSteps > 9;
    return (
      <ExplainerPopover
        icon={
          completed ? (
            <RiCheckboxCircleFill color="var(--mantine-color-success-4)" size={20} />
          ) : active ? (
            <RiEdit2Line color="var(--mantine-color-primary-4)" size={20} />
          ) : (
            <RiTodoLine color="var(--mantine-color-gray-4)" size={20} />
          )
        }
        title={`Step ${index} of ${totalSteps}`}
        subTitle={label}
        target={
          <Stack
            align="center"
            gap={20}
            className={classes.step}
            data-active={active}
            ref={ref}
          >
            <Group gap={6} wrap="nowrap" justify="center">
              {!completed ? (
                <Badge
                  size="md"
                  circle
                  w={hasDoubleDigitSteps ? 26 : 20}
                  h={hasDoubleDigitSteps ? 26 : 20}
                  fz={hasDoubleDigitSteps ? 10 : 11}
                  fw={600}
                  mod={{ completed, active }}
                  className={classes.stepBadge}
                >
                  {index}
                </Badge>
              ) : (
                <RiCheckboxCircleFill
                  color="var(--mantine-color-success-4)"
                  size={hasDoubleDigitSteps ? 28 : 24}
                />
              )}
              {active ? (
                <Text
                  fz={14}
                  fw={500}
                  lh={1}
                  component="div"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {label}
                </Text>
              ) : null}
            </Group>
            <Divider
              size={3}
              className={classes.stepDivider}
              mod={{ completed, active }}
            />
          </Stack>
        }
      />
    );
  }
);
